import React, { useEffect, useState, useContext } from "react";
import { withRouter, Switch, Route, Redirect } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import ProjectTablePageNew from "../project-table-page/project-table-page.jsx";
import NoPermissionTable from "../../../../components/no-permission-table/NoPermissionTable";
import { LoginContext } from "../../../../services/api/authentication-api";
import { User_Logout } from "../../../../services/auth";
import "./projects-page.scss";
import ProjectCreate from "../project-create-edit/project-create/project-create";
import ProjectEdit from "../project-create-edit/project-edit/project-edit";


const ProjectsPageNew = () => {
    const context = useContext(LoginContext);
    const labels = context?.currentUser?.objectLabels;
    const [dateFormatID] = useState(context.currentUser?.department?.dateFormatID === 2 ? "en-US" : "en-GB");
    const [privileges] = useState(context.currentUser?.privileges ?? {});

    useEffect(() => {
        if (context.currentUser == null) User_Logout();
    }, [context.currentUser]);

    return (
        <div className="projects-page">
            <Helmet>
                <title>TRIYO · {labels?.ProjectPlural ?? "Projects"}</title>
            </Helmet>
            <Switch>
                <Route exact path="/projects">
                    {privileges && privileges["Projects"] && !privileges["Projects"].View ?
                        <NoPermissionTable />
                        :
                        <ProjectTablePageNew dateFormatID={dateFormatID} privileges={privileges} />
                    }

                </Route>
                <Route exact path="/projects/create">
                    <ProjectCreate />
                </Route>
                <Route path="/projects/edit/">
                    <ProjectEdit/>
                </Route>               
                <Route exact path="/">
                    <Redirect to="/projects" />
                </Route>
            </Switch>
        </div>
    );
};

export default withRouter(ProjectsPageNew);
